module.exports = require("pdfmake/build/pdfmake.js");


//////////////////
// WEBPACK FOOTER
// external "pdfmake/build/pdfmake.js"
// module id = 1070
// module chunks = 